import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import EditIcon from "@mui/icons-material/Notes";
// import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import WorkIcon from "@mui/icons-material/Work";
import Template from "../Details/template/Template";
import Profile from "../Details/profile/Profile";
import StyleView from "../Details/style/Style";
import style from "./sidebar.module.css";

import { Image, Brush, Apps } from "@mui/icons-material";
import Features from "../Details/Features/Features";
import Banner from "../Features/banner/Banner";
import { AppBar } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {<Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div
      className={`bg-blue text-white p-0  ${style.sidebarTabination}`}
      style={{ width: "400px" }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        className={`${style.tabsWrapper}`}
      >
        <Tab
          className={`${style.tabsItem}`}
          icon={<WorkIcon />}
          {...a11yProps(0)}
          style={{
            background: value === 0 ? "#334165" : "#3E5974",
            color: value === 0 ? "white" : "white",
          }}
        />
        <Tab
          className={`${style.tabsItem}`}
          icon={<EditIcon />}
          {...a11yProps(1)}
          style={{
            background: value === 1 ? "#334165" : "#3E5974",
            color: value === 1 ? "white" : "white",
          }}
        />
        <Tab
          className={`${style.tabsItem}`}
          icon={<Brush />}
          {...a11yProps(2)}
          style={{
            background: value === 2 ? "#334165" : "#3E5974",
            color: value === 2 ? "white" : "white",
          }}
        />

        <Tab
          className={`${style.tabsItem}`}
          icon={<Apps />}
          {...a11yProps(3)}
          style={{
            background: value === 3 ? "#334165" : "#3E5974",
            color: value === 3 ? "white" : "white",
          }}
        />

        {/* <Tab className={`${style.tabsItem}`} icon={<ImageIcon />}  {...a11yProps(3)} /> */}
      </Tabs>

      <TabPanel
        value={value}
        index={0}
        className={`${style.tabpanels} ${!isAuth ? `${style.active}` : null}`}
      >
        <Template />
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        className={`${style.tabpanels} ${!isAuth ? `${style.active}` : null}`}
      >
        <Profile />
      </TabPanel>
      <TabPanel
        value={value}
        index={2}
        className={`${style.tabpanels} ${!isAuth ? `${style.active}` : null}`}
      >
        <StyleView />
      </TabPanel>
      <TabPanel
        value={value}
        index={3}
        className={`${style.tabpanels} ${!isAuth ? `${style.active}` : null}`}
      >
        <Features />
      </TabPanel>
    </div>
  );
}
